import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';
import { Checkbox } from '../../../components/ui/Checkbox';

const PostCard = ({ post, onEdit, onDelete, selected, onSelectChange }) => {
  return (
    <div className="overflow-hidden rounded-xl bg-card shadow-card">
      <div className="flex flex-col sm:flex-row">
        <div className="w-full sm:w-44">
          <div className="aspect-[9/16] w-full overflow-hidden bg-muted">
            <Image
              src={post?.image_url}
              alt={'Before & After'}
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        <div className="flex flex-1 flex-col justify-between gap-4 p-4">
          <div className="space-y-2">
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="line-clamp-3 whitespace-pre-line text-sm text-muted-foreground">
                  {post?.content || '내용 없음'}
                </p>
              </div>
              <Checkbox
                id={post?.id ? `before-after-select-${post.id}` : undefined}
                checked={!!selected}
                onChange={(e) => onSelectChange?.(post?.id, e?.target?.checked)}
                aria-label="선택"
              />
            </div>

            {post?.created_at && (
              <p className="text-xs text-muted-foreground">
                등록일: {new Date(post.created_at).toISOString().slice(0, 10)}
              </p>
            )}
          </div>

          <div className="flex items-center justify-end gap-2">
            <Button
              variant="outline"
              size="sm"
              iconName="Pencil"
              iconPosition="left"
              onClick={() => onEdit?.(post)}
            >
              수정
            </Button>
            <Button
              variant="danger"
              size="sm"
              iconName="Trash2"
              iconPosition="left"
              onClick={() => onDelete?.(post?.id)}
            >
              삭제
            </Button>
          </div>
        </div>
      </div>

      <div className="border-t border-border bg-muted/30 px-4 py-3">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="Link" size={14} />
          <span className="truncate">{post?.image_url}</span>
        </div>
      </div>
    </div>
  );
};

export default PostCard;
